import Vue from '@/main'
import { DateTime } from 'luxon'
import { dateFormat } from '@/utils/dateUtil.js'
import { capitalizeFirstLetter } from '@/utils/stringUtil.js'

const CHART_DATASET_BG_COLORS = {
  1: '#403266',
  2: '#AC9FD0',
  3: '#A4DDED',
  4: '#F5F3FA',
}

const getLabelByMonth = (referenceDate) => capitalizeFirstLetter(referenceDate.toFormat('MMMM'))

const getDatasets = (statisticsProperties) => {
  const datasets = []

  statisticsProperties.forEach((item, index) => {
    const dataset = {}

    const statisticProperty = item.name

    dataset.label = Vue.$t(`automation.statistics.chart.statistic.${statisticProperty}`)

    dataset.backgroundColor = CHART_DATASET_BG_COLORS[index + 1]

    dataset.value = item.value

    datasets.push(dataset)
  })

  return datasets
}

const setDatasetData = (referenceDate, datasets) => {
  datasets.forEach((dataset) => {
    const valueByMonth = dataset.value.filter((item) => {
      const itemDateTime = DateTime.fromISO(item.timestamp)
      const isSameMonthAndYear = itemDateTime.month === referenceDate.month && itemDateTime.year === referenceDate.year
      return isSameMonthAndYear
    })

    const monthlyTotalCount = valueByMonth.reduce((total, item) => total + item.count, 0)

    if(!dataset.data) dataset.data = []

    dataset.data.push(monthlyTotalCount)
  })
}

const getGroupedDataByMonth = (statisticsProperties, months) => {
  const startDate = dateFormat(DateTime.now().minus({ months }))
  let referenceDate = startDate.startOf('month')
  const endDate = dateFormat(DateTime.now())

  const labels = []
  const datasets = getDatasets(statisticsProperties)

  while (referenceDate.toISODate().slice(0, 7) <= endDate.toISODate().slice(0, 7) /* Extract the year and month part */) {
    labels.push(getLabelByMonth(referenceDate))

    setDatasetData(referenceDate, datasets)
    referenceDate = referenceDate.plus({ months: 1 })
  }

  return { labels, datasets }
}

const getGroupedChartData = (statisticsProperties, months) => {
  const { labels, datasets } = getGroupedDataByMonth(statisticsProperties, months)

  return { labels, datasets }
}

export { CHART_DATASET_BG_COLORS, getGroupedChartData }
